module.exports = __webpack_public_path__ + "static/media/Nuvama_Identity_RGB_Positive.607aa283.jpg";